import { useEffect } from 'react';

const SUPERCHAT_APPLICATION_KEY = 'WCZd6zDLb2aENNyWE85AYGvePV';
const SCRIPT_ID = 'superchat-widget-script';

const SuperchatWidget = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `https://widget.superchat.de/snippet.js?applicationKey=${SUPERCHAT_APPLICATION_KEY}`;
    script.referrerPolicy = 'no-referrer-when-downgrade';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.getElementById(SCRIPT_ID)?.remove();

      document
        .querySelectorAll('[id*="superchat"], [class*="superchat"]')
        .forEach((el) => el.remove());

      document
        .querySelectorAll('iframe[src*="superchat"]')
        .forEach((el) => el.remove());
    };
  }, []);

  return null;
};

export default SuperchatWidget;
